import { FeatureState, IContentAPIFeatureState } from "./ConfigurationState";

export type ItemListConfigurationState = Array<ItemListFeatureState>;
export type IContentAPIItemListConfigurationState = Array<IContentAPIItemListFeatureState>;

export class ItemListFeatureStateFactory {
    static create(featureState: IItemListFeatureState): IContentAPIItemListFeatureState {
        return new ItemListFeatureState(featureState).serialize();
    }

    static createMany(featureStates: IItemListFeatureState[]): IContentAPIItemListConfigurationState {
        return featureStates.map((featureState: IItemListFeatureState) => ItemListFeatureStateFactory.create(featureState));
    }
}

export class ItemListConfigurationStateFactory {
    static create(configurationState: IItemListConfigurationState): IContentAPIItemListConfigurationState {
        return ItemListFeatureStateFactory.createMany(configurationState);
    }
}

export class ItemListFeatureState extends FeatureState {
    protected _featureName?: string;
    protected _optionName?: string;

    constructor(featureState: IItemListFeatureState) {
        super(featureState);
        this._featureName = featureState.featureName;
        this._optionName = featureState.optionName;
    }

    serialize(): IContentAPIItemListFeatureState {
        const featureState: IContentAPIItemListFeatureState = super.serialize();

        if (this._featureName !== undefined) {
            featureState.featureName = this._featureName;
        }

        if (this._optionName !== undefined) {
            featureState.optionName = this._optionName;
        }

        return featureState;
    }
}

export interface IContentAPIItemListFeatureState extends IContentAPIFeatureState {
    featureName?: string;
    optionName?: string;
}